import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { ApiService, HttpMethod } from '../api/api.service';

export interface MeCapabilities {
  canViewAdministration: boolean;
  canViewOrganizationGroups: boolean;
  canViewAuditTrail: boolean;
  canManageOrganizations: boolean;
  canManageGroups: boolean;
  canAssignSupervisor: boolean;
  canCreateUser: boolean;
  canDeleteUser: boolean;
  canSwitchActiveOrg: boolean;
  canViewUserEmails: boolean;
}

export interface InviteContext {
  allowedRoles: string[];
  organizationId: number | null;
  organizationName: string | null;
  organizationGroupId: number | null;
  organizationGroupName: string | null;
  organizationLocked: boolean;
  organizationGroupLocked: boolean;
}

@Injectable({ providedIn: 'root' })
export class MeService {
  constructor(private apiService: ApiService) {}

  getCapabilities(): Observable<MeCapabilities> {
    return from(
      this.apiService.call<MeCapabilities>(HttpMethod.GET, 'me/capabilities'),
    );
  }

  getInviteContext(): Promise<InviteContext> {
    return this.apiService.call<InviteContext>(HttpMethod.GET, 'me/invite-context');
  }
}
